import React, { useEffect, useState } from "react"; 
import './index.scss'; 
import Tags from '../tags'

import ReactEcharts from "echarts-for-react"; 
import { formatNumber } from "@/tool/utils";
import LoadingOutlined from "../loadingOutlined/chartloading";
import UpdatTime from "./updateTime";


type Props = {
    updateTime: number,
    yData: string[],
    datas: any[],
    loading: boolean
};

export default function Index(props: Props) {
    const getChartOption = () => {

        let zoomStart = 80;
        const length = props.yData?.length || 0;
        if (length <= 20) {
            zoomStart = 50
        } else if (length <= 50) {
            zoomStart = 80
        } else if (length <= 200) {
            zoomStart = 90
        } else if (length > 200) {
            zoomStart = 95
        }

        const yData = props.yData ? props.yData.map((title => {
            return `${title.slice(0, 4)}/${title.slice(4, 6)}/${title.slice(6, 8)}`;
        })) : []
        return {
            color: props.datas.map((item: any) => {
                return item.color
            }),
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    lineStyle: {
                        color: "#9DAFBE"
                    }
                },
                formatter: (params: any) => {

                    // console.log("params[0]", params);
                    let title = params[0].name;
                    let itemDiv = params.map((item: any) => {
                        const value = item.data === 0.1 ? 0 : item.data;
                        return `<div class="tooltipItem">
                            <div>${item.marker}${item.seriesName}</div>
                            <div>${formatNumber(value, { decimals: 2 })}</div>
                        </div>`
                    })
                    title=title.replace(/\//g,'-')
                    return `<div class="tooltipContainer">
                        <div class="title">${title}</div>
                        ${itemDiv.join('')}
                    </div>`;
                },
            },

            dataZoom: [
                {
                    start: zoomStart,
                    end: 100,
                    right: "70px",
                    left: "70px",
                    bottom: "10px",
                    textStyle: {
                        color: "#9dafbe",
                        fontFamily: "Arial"
                    },
                    dataBackground: {                        //数据阴影的样式。
                        lineStyle: {
                            color: "#9dafbe"
                        },              //阴影的线条样式
                        areaStyle: {
                            color: "#9dafbe"
                        },              //阴影的填充样式
                    },
                },
                {
                    type: 'inside',
                    realtime: true,
                    start: zoomStart,
                    end: 100
                }
            ],
            grid: {
                left: '3%',
                right: '10%',
                bottom: '15%',
                top: '3%',
                containLabel: true
            },

            xAxis: {
                type: 'category',
                boundaryGap: false,
                axisLabel: {
                    color: "#9dafbe",
                    formatter: (item: any) => {
                        const itemArray = item.split('/')
                        return `${itemArray[1]}-${itemArray[2]}`;
                    },
                    fontFamily: "Arial",
                    margin: 6
                },
                axisTick: {
                    show: false
                },
                data: yData,
                axisLine: {
                    lineStyle: {
                        color: '#9dafbe'
                    }
                }
            },
            yAxis: {
                type: 'log',
                axisLabel: {
                    formatter: (value: any) => {
                        return formatNumber(value, { decimals: 2 });
                    },
                    color: "#9dafbe",
                    fontFamily: "Arial",
                    margin: 6
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: "#1A283533",
                        width: 1,
                    },
                },

                axisLine: {
                    lineStyle: {
                        color: '#9dafbe'
                    }
                }
            },
            series: props.datas.map((item) => {
                item.symbol = 'none';
                item.data = item.data.map((e: any) => {
                    if (e === 0) {
                        return undefined
                    } else {
                        return e
                    }
                })
                return item
            })
        }


    };


    return (
        <div className="echartsContainer">
            <div className="echartsPanel" >
                <LoadingOutlined spin={props.loading}>
                    <div className="echarts">
                        <ReactEcharts className="echarts-body" option={getChartOption()}></ReactEcharts>
                    </div>
                    <Tags datas={props.datas} />
                    <UpdatTime updateTime={props.updateTime} />
                </LoadingOutlined>
            </div>
        </div>
    );
}
